import { debounce } from "lodash";
import { observer } from "mobx-react-lite";
import React, { FC, useCallback, useState } from "react";
import { ValidationRunTable } from "../components/tables/ValidationRunTable";
import { FilterSearchBar } from "../controllers/FilterSearchBar";
import { PageHeader } from "../components/pageHeader/PageHeader";
import { useLocation } from "react-router-dom";
import { URL_QUERY_PARAMS } from "../stores/url.store";
import { NotificationMenu } from "../components/notifications/NotificationMenu";

export const ValidationRunsLayout: FC<{}> = observer(() => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const search = params.get(URL_QUERY_PARAMS.SEARCH);
  const [searchString, setSearchString] = useState<string>(search ?? "");

  const debouncedSetFilter = debounce(setSearchString, 300);
  const onSearchStringChange = useCallback(
    (newSearchString: string): void => {
      debouncedSetFilter(newSearchString);
    },
    [debouncedSetFilter]
  );

  return (
    <>
      <NotificationMenu />
      <PageHeader breadcrumbsDepth={3} />
      <FilterSearchBar
        filter={searchString}
        onFilterChange={onSearchStringChange}
        placeholderText={"Search"}
        defaultFilter=""
      />
      <ValidationRunTable />
    </>
  );
});
